import * as echarts from "echarts/core";
import { BarChart, LineChart, PieChart } from "echarts/charts";

import {
  GridComponent,
  TooltipComponent,
  LegendComponent,
  DatasetComponent,
  TransformComponent,
  VisualMapComponent,
} from "echarts/components";

import { CanvasRenderer } from "echarts/renderers";

echarts.use([
  BarChart,
  LineChart,
  PieChart,
  CanvasRenderer,
  GridComponent,
  TooltipComponent,
  LegendComponent,
  DatasetComponent,
  TransformComponent,
  VisualMapComponent,
]);

export default echarts;
